import { useMemo } from "react";
import { useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";

import { SearchFilterItem } from "@/types/SearchFilterItem.type";
import FormDatePicker from "@/components/atoms/FormDatePicker";
import FilterSectionItem from "@/components/molecules/filter/FilterSectionItem";
import FormOptionCheckboxes from "@/components/molecules/form/FormOptionCheckboxes";

export enum PredefinedFoundingDateRange {
  LAST_3_MONTHS = "LAST_3_MONTHS",
  LAST_6_MONTHS = "LAST_6_MONTHS",
  LAST_12_MONTHS = "LAST_12_MONTHS",
  OLDER_12_MONTHS = "OLDER_12_MONTHS",
}

const FoundingDateFilter = ({ name }: SearchFilterItem) => {
  const { t } = useTranslation();
  const { watch } = useFormContext();

  const foundingDateFilter = watch(["foundingDate.min", "foundingDate.max"]);
  const predefinedFoundingDateFilter = watch("predefinedFoundingDate");

  const filterCount = useMemo(() => {
    return (
      Object.values(foundingDateFilter).filter((value) => value).length + (predefinedFoundingDateFilter?.length || 0)
    );
  }, [foundingDateFilter]);

  const predefinedFoundingDateRanges = [
    PredefinedFoundingDateRange.LAST_3_MONTHS,
    PredefinedFoundingDateRange.LAST_6_MONTHS,
    PredefinedFoundingDateRange.LAST_12_MONTHS,
    PredefinedFoundingDateRange.OLDER_12_MONTHS,
  ];

  return (
    <FilterSectionItem
      id={name}
      title={t("search.filter.foundingDate.title")}
      filterCount={filterCount}
      tooltip={t("search.filter.foundingDate.tooltip")}
    >
      <FormOptionCheckboxes
        name={"predefinedFoundingDate"}
        options={predefinedFoundingDateRanges.map((range) => ({
          id: range,
          label: t(`search.filter.foundingDate.predefined.${range}`),
          value: range,
        }))}
      />

      <FormDatePicker name={"foundingDate.min"} label={t("search.filter.foundingDate.from")} />
      <FormDatePicker name={"foundingDate.max"} label={t("search.filter.foundingDate.to")} />
    </FilterSectionItem>
  );
};

export default FoundingDateFilter;
